import React, { useState, useEffect } from "react";

import MapsLeaflet from "../maps/maps_leaflet";
import Api from "shared/resources/Api";
import { DataMap, calcZone, getType } from "../maps/dataMap";
import { Container, Row, Col, Modal, ModalBody } from "reactstrap";
import "react-image-lightbox/style.css";

const OvitrampMap = () => {
  const callApi = async () => {
    let response = await fetch(Api.baseURL + "/ovitrampa/posicao", {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });
    let body = await response.json();

    if (body.data) {
      for (let item of body.data) {
        if (item.CD_CODIGO) {
          item.OID_OVITRAMPA = item.CD_CODIGO;
        }
      }
    }

    setDadosMapa(body.data);

    response = await fetch(Api.baseURL + "/ovitrampa/setor", {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });
    body = await response.json();

    setSetores(body.data);

    return true;
  };

  const callApiTipo = async () => {
    let body, response, tmp;

    response = await fetch(Api.baseURL + "/ovitrampa/piscina", {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });
    body = await response.json();
    setDadosPiscina(body.data);

    response = await fetch(Api.baseURL + "/ovitrampa/ponto_estrategico", {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });
    body = await response.json();
    setDadosPontoEstrategico(body.data);

    response = await fetch(Api.baseURL + "/ovitrampa/grandes_areas", {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });
    body = await response.json();
    setDadosGrandeArea(body.data);

    response = await fetch(Api.baseURL + "/ovitrampa/imovel_abandonado", {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });
    body = await response.json();
    setDadosImovelAbandonado(body.data);

    response = await fetch(Api.baseURL + "/ovitrampa/controle_biologico", {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });
    body = await response.json();
    setDadosControleBiologico(body.data);

    response = await fetch(Api.baseURL + "/ovitrampa/borracharia", {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });
    body = await response.json();
    setDadosBorracharia(body.data);


    response = await fetch(Api.baseURL + "/ovitrampa/armadilha", {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });
    body = await response.json();
    setDadosArmadilha(body.data);


    response = await fetch(Api.baseURL + "/dados/dengue", {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });
    body = await response.json();
    let tmpData = {};

    // Processa dados diários
    tmpData.day = DataMap(formataDados(body.dados.day));
    tmpData.day = calcZone(tmpData.day);
    let tmpDay = {};
    tmpData.day.forEach((item) => {
      tmpDay[item.name === "CENTRO" ? "CENTRAL" : item.name] = item.Casos;
    });

    // Processa dados semanais
    tmpData.week = DataMap(formataDados(body.dados.week));
    tmpData.week = calcZone(tmpData.week);
    let tmpWeek = {};
    tmpData.week.forEach((item) => {
      tmpWeek[item.name === "CENTRO" ? "CENTRAL" : item.name] = item.Casos;
    });

    // Processa dados mensais
    tmpData.month = DataMap(formataDados(body.dados.month));
    tmpData.month = calcZone(tmpData.month);
    let tmpMonth = {};
    tmpData.month.forEach((item) => {
      tmpMonth[item.name === "CENTRO" ? "CENTRAL" : item.name] = item.Casos;
    });

    // Processa dados anuais
    tmpData.year = DataMap(formataDados(body.dados.year));
    tmpData.year = calcZone(tmpData.year);
    let tmpYear = {};
    tmpData.year.forEach((item) => {
      tmpYear[item.name === "CENTRO" ? "CENTRAL" : item.name] = item.Casos;
    });

    setDadosDengue({
      day: tmpDay,
      week: tmpWeek,
      month: tmpMonth,
      year: tmpYear,
    });
  };
  const formataDados = (dados = []) => {
    let tmp = [];
    if (dados.length == 0) {
      return [];
    }
    dados.forEach((item) => {
      tmp.push({
        type: item.nm_bairro,
        value: item.total_registros,
      });
    });
    return tmp;
  };
  const casos = {
    CENTRAL: 0,
    NORTE: 0,
    SUL: 0,
    LESTE: 0,
    OESTE: 0,
    RURAL: 0,
    DISTRITO: 0,
    "NAO IDENTIFICADO": 0,
    OUTROS: 0,
  };

  const [dadosDengue, setDadosDengue] = useState({
    day: casos,
    week: casos,
    month: casos,
    year: casos,
  });
  const [showMap, setShowMap] = useState(false);
  const [dadosMapa, setDadosMapa] = useState([]);
  const [setores, setSetores] = useState([]);
  const [dadosPiscina, setDadosPiscina] = useState([]);
  const [dadosPontoEstrategico, setDadosPontoEstrategico] = useState([]);
  const [dadosGrandeArea, setDadosGrandeArea] = useState([]);
  const [dadosImovelAbandonado, setDadosImovelAbandonado] = useState([]);
  const [dadosControleBiologico, setDadosControleBiologico] = useState([]);
  const [dadosBorracharia, setDadosBorracharia] = useState([]);
  const [dadosArmadilha, setDadosArmadilha] = useState([]);

  useEffect(() => {
    callApi();
    callApiTipo();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      callApi();
    }, 50000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {showMap && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "white",
            zIndex: 1000,
            padding: "20px",
            borderRadius: "5px",
            border: "5px solid rgb(24, 144, 255)",
            borderBottom: "none",
          }}
          onKeyDown={(e) => {
            if (e.key === "Escape") {
              setShowMap(false);
            }
          }}
          tabIndex={0}
        >
          <button
            className="btn btn-danger mb-3"
            onClick={() => setShowMap(false)}
            style={{
              position: "absolute",
              right: "20px",
              top: "20px",
              cursor: "pointer",
              zIndex: 1001, // Garante que o botão fique acima do conteúdo
            }}
            type="button" // Explicita que é um botão clicável
          >
            Fechar
          </button>
          <div style={{ width: "100%", height: "100%" }}>
            <MapsLeaflet
              dados={dadosMapa}
              setor={setores}
              dadosPiscina={dadosPiscina}
              dadosPontoEstrategico={dadosPontoEstrategico}
              dadosGrandeArea={dadosGrandeArea}
              dadosImovelAbandonado={dadosImovelAbandonado}
              dadosControleBiologico={dadosControleBiologico}
              dadosBorracharia={dadosBorracharia}
              dadosArmadilha={dadosArmadilha}
              dadosDengue={dadosDengue}
            />
          </div>
        </div>
      )}

      <Container className="mb-7 mt-5" fluid>
        <div className="mb-3" style={{ height: "6vw" }}></div>

        <div
          className="mb-3 d-flex flex-column align-items-start"
          style={{ height: "60px", marginBottom: "20px", top: "180px" }}
        >
          <div className="d-flex align-items-start">
            <button
              className="btn btn-primary mb-3"
              onKeyDown={(e) => {
                if (e.key === "Escape") {
                  setShowMap(false);
                }
              }}
              onClick={() => setShowMap(!showMap)}
            >
              Mostrar mapa
            </button>
          </div>
        </div>
        <div className="mb-3" style={{ height: "15vw" }}></div>
      </Container>
    </>
  );
};

export default OvitrampMap;
